<ng-container *ngIf="reportList && reportList.length !=0; else noList">
    <div class="ms-auto filter-div">
        <button type="button" class="btn btn-outline-primary" (click)="refreshBugReports();" ngbTooltip="Refresh" aria-label="Refresh">
            <fa-icon [icon]="faRotateRight" [spin]="isLoading"></fa-icon>
        </button>
        <span class="ms-2"></span>
        <ng-container *ngTemplateOutlet="SORT_DROPDOWN"></ng-container>
        <span class="ms-2"></span>
        <ng-container *ngTemplateOutlet="FILTER_DROPDOWN"></ng-container>
    </div>
    <!-- <div class="row overflow-auto" style="max-height: 87vh;">
        <div *ngFor="let report of reportListFiltered; let i = index" class="col-sm-12 light-green"
        (click)="setSelectedReport(report.id)" [class.selected]="selectedId == report.id">
            <div class="py-2 mb-1 cursor-pointer">
                <div class="row">
                    <div class="col-md-8"> 
                        <span><b>{{report.id}}</b></span>
                    </div>
                    <div class="col-md-4 justify-content-end text-end">
                        <span class="tag" [ngClass]="report.status.toLowerCase().replaceAll(' ', '_')">
                            {{ renameStatuses(report.status) }}</span>
                    </div>
                </div>
                <div class="row">
                    <p class="mb-0 py-2">
                        {{ report.title }}
                    </p>
                </div>
                <div class="row text-end">
                   <span class="small-date">{{ report.createdAt * 1000 | date : 'MM-dd-yyyy' }}</span> 
                </div>
            </div>
            <div class="px-1" *ngIf="!(i == reportList.length -1)">
                <hr class="my-0" />
            </div>
        </div>
       
    </div> -->

    <div class="scrollable mt-2">
        <ul class="list-group">
          <li *ngFor="let report of reportListFiltered; let i = index" class="list-group-item list-group-item-action"
            (click)="setSelectedReport(report.id)" [class.selected]="selectedId == report.id" style="cursor: pointer;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <strong>{{report.id}}</strong>
                <span>{{ report.title }}</span>
              </div>
              <div class="d-flex flex-column align-items-end">
                <span class="tag" [ngClass]="report.status.toLowerCase().replaceAll(' ', '_')"> 
                  {{ renameStatuses(report.status) }}
                </span>
                <span class="small-date">{{ report.createdAt * 1000 | date : 'MM-dd-yyyy' }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      
</ng-container>
<ng-template #noList>
    <!-- TODO Add no list -->
</ng-template>

<!-- Sort Dropdown -->
<ng-template #SORT_DROPDOWN>
    <div ngbDropdown class="d-inline-block" [autoClose]="true">
        <button class="btn btn-outline-primary" ngbDropdownToggle ngbTooltip="Sort" aria-label="Sort">
            <fa-icon [icon]="faSortAmountDownAlt"></fa-icon>
        </button>
        <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="setSort('createdAt');">
                Created
                <fa-icon *ngIf="sortBy == 'createdAt'" [icon]="(sortDirection == 'ASC' ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
            </button>
        </div>
    </div>
</ng-template>

<!-- Filter Dropdown -->
<ng-template #FILTER_DROPDOWN>
    <div ngbDropdown class="d-inline-block" autoClose="outside">
        <span *ngIf="selectedFilters.length > 0" class="custom-badge-lg">{{selectedFilters.length}}</span>
        <button class="btn btn-outline-primary" ngbDropdownToggle ngbTooltip="Filter" aria-label="Filter">
            <fa-icon [icon]="faFilter"></fa-icon>
        </button>
        <div ngbDropdownMenu>
            <!-- Status -->
            <button ngbDropdownItem (click)="statusCollapse.toggle();">Status</button>
            <div class="px-4 py-1" #statusCollapse="ngbCollapse" [ngbCollapse]="true">
                <div class="d-flex flex-column">
                    <div *ngFor="let element of columnFilterValues.get('status');" class="form-check form-check-inline">
                        <input [id]="element.value" class="form-check-input" [checked]="checkIfSelected(element)" type="checkbox" (change)="addRemoveFilter('status', element.value);">
                        <label [for]="element.value" class="form-check-label" style="white-space: nowrap;">{{element.name}}</label>
                    </div>
                </div>
            </div>
            <!-- Divider -->
            <div class="dropdown-divider"></div>
            <!-- Reset -->
            <button ngbDropdownItem (click)="resetActiveFilters(); statusCollapse.toggle();">Reset</button>
        </div>
    </div>
</ng-template>